"use client";

import React, { useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CircleCheck, Mail, Phone, House } from "lucide-react";
export default function ThankYouConfirmation() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (typeof window.fbq === "function") {
        window.fbq("track", "Lead");
      }
    }
  }, []);
  return <section id="thank-you-confirmation" className="bg-background relative overflow-hidden py-16 sm:py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-accent-gold-light),_transparent_50%)] opacity-50 pointer-events-none"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10">
        <div className="flex flex-col items-center text-center space-y-10">
          
          {}
          <div className="flex flex-col items-center space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-700">
            <div className="h-20 w-20 bg-primary/5 rounded-full flex items-center justify-center mb-2 shadow-sm border border-primary/10">
              <CircleCheck className="h-10 w-10 text-primary" />
            </div>
            <Badge variant="outline" className="border-primary/20 text-primary bg-primary/5 px-4 py-1.5 text-sm font-medium rounded-full">
              Request Received Successfully
            </Badge>
          </div>

          {}
          <div className="space-y-6 max-w-3xl animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100 fill-mode-both">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-default tracking-tight text-foreground leading-tight">Thank You! I'm Finding Your <span className="text-accent-gold-dark relative whitespace-nowrap" data-ast-id="f:/src/pages/ThankYou/sections/ThankYouConfirmation.tsx|sig:u2gid4" data-ast-start="1923" data-ast-end="2309">Dream House<svg className="absolute -bottom-2 left-0 w-full h-3 text-accent-gold/30" viewBox="0 0 100 10" preserveAspectRatio="none" data-ast-id="f:/src/pages/ThankYou/sections/ThankYouConfirmation.tsx|sig:t1au9" data-ast-start="2035" data-ast-end="2287"><path d="M0 5 Q 50 10 100 5" stroke="currentColor" stroke-width="4" fill="transparent" data-ast-id="f:/src/pages/ThankYou/sections/ThankYouConfirmation.tsx|sig:8twyjd" data-ast-start="2176" data-ast-end="2264"></path></svg></span></h1>
            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">Check your email for exclusive listings arriving within 24 hours.<div><br /></div><div>Hi, I’m Anish Patel — a local real estate advisor serving Naperville, Lisle, Plainfield, Aurora, Oswego, Bolingbrook and surrounding areas. I’ll personally review your preferences and follow up shortly with homes and opportunities that fit your goals.</div></p>
          </div>

          {}
          <div className="w-full max-w-4xl mx-auto mt-8 relative rounded-2xl overflow-hidden shadow-2xl border border-border/50 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200 fill-mode-both">
            
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none"></div>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl mt-12 text-left animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300 fill-mode-both">
            <Card className="bg-card/80 backdrop-blur-sm border-border/60 shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-6 sm:p-8 flex items-start space-x-5">
                <div className="bg-accent-gold/10 p-3.5 rounded-xl shrink-0">
                  <Mail className="h-6 w-6 text-accent-gold-dark" />
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold font-default text-xl text-foreground">What happens next?</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">You’ll receive a follow-up shortly. I’ll personally review your criteria and send curated listings that fit your goals and budget.</p>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-card/80 backdrop-blur-sm border-border/60 shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-6 sm:p-8 flex items-start space-x-5">
                <div className="bg-primary/10 p-3.5 rounded-xl shrink-0">
                  <Phone className="h-6 w-6 text-primary" />
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold font-default text-xl text-foreground">Need immediate help?</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">Call or text me directly anytime.</p>
                  <div className="pt-2">
                    <Button variant="link" className="p-0 h-auto text-primary font-semibold text-base hover:text-primary/80" asChild>
                      <Link to="tel:+15551234567">Call (815) 546 - 0725</Link>
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="pt-10 animate-in fade-in duration-700 delay-500 fill-mode-both">
            <Button size="lg" className="rounded-full px-8 h-12 text-base shadow-md" asChild>
              <Link to="/">
                <House className="mr-2 h-5 w-5" />
                Return to Homepage
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}